import SalaryCompensation from "./salaryCompensation";
export default SalaryCompensation;